import React, { useEffect } from "react";
import {
  HashRouter,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import AddExpenses from "./pages/AddExpenses";
import Home from "./pages/Home";
import EditExpense from "./pages/EditExpense";
import SearchScreen from "./pages/SearchScreen";
import DetailsScreen from "./pages/DetailsScreen";
import Navbar from "./pages/Navbar";
import Settings from "./pages/Settings";
import ManageCategories from "./pages/ManageCategories";
import AddCategory from "./pages/AddCategory";
import EditCategory from "./pages/EditCategory";
import SearchResult from "./pages/SearchResult";
import Admin from "./pages/Admin";
import FourZeroFour from "./pages/FourZeroFour";
import Onboarding from "./pages/Onboarding";

const App = () => {
  const AppContent = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      const onboardingShow = localStorage.getItem("onboardingShow") || "false";
       if (onboardingShow === "false") {
        navigate("/Onboarding");
      }
    }, [navigate]);

    return (
      <>
        <div>
          {location.pathname !== "/Payment" &&
            location.pathname !== "/FAQ" &&
            location.pathname !== "/Onboarding" &&
            location.pathname !== "/ForgotPassword" &&
            location.pathname !== "/Signup" && <Navbar />}
          <div className="container">
            <Routes>
              <Route path="/AddExpenses" exact element={<AddExpenses />} />
              <Route path="/admin-panel" element={<Admin />} />
              <Route path="/SearchScreen" element={<SearchScreen />} />
              <Route path="/Onboarding" element={<Onboarding />} />
              <Route path="/edit/:expenseId" element={<EditExpense />} />
              <Route path="/ManageCategories" element={<ManageCategories />} />
              <Route
                path="/editcategory/:categoryId"
                element={<EditCategory />}
              />
              <Route path="*" element={<FourZeroFour />} />
              <Route path="/Settings" element={<Settings />} />
              <Route path="/SearchResults" element={<SearchResult />} />
              <Route path="/AddCategory" element={<AddCategory />} />

              <Route path="/" element={<Home />} />
              <Route
                path="/details/:category/:selectedFilter"
                element={<DetailsScreen />}
              />
            </Routes>
          </div>
        </div>
      </>
    );
  };

  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
};

export default App;
